import React, { FC } from 'react';
import classNames from 'classnames';
import { CarouselProps } from './CarouselProps';
import styles from './Carousel.module.scss';
import getClassNames from '../../utils/getClassNames';

const SimpleCarousel: FC<CarouselProps> = ({ children, classNameModifier }) => (
  <div className={getClassNames(styles, 'container', classNameModifier)}>
    <div className={getClassNames(styles, 'viewport', classNameModifier)}>
      <ul className={getClassNames(styles, 'list', classNames('simple', classNameModifier))}>
        {children}
      </ul>
    </div>
  </div>
);

export default SimpleCarousel;
